export const ANNUITY_DATA_REQUEST = 'ANNUITY_DATA_REQUEST';
export const ANNUITY_DATA_SUCCESS = 'ANNUITY_DATA_SUCCESS';
export const ANNUITY_DATA_FAIL = 'ANNUITY_DATA_FAIL';
